export default element => {
    //var forId = "@Model.SystemId.ToString()";
    const galleryExtraButton = document.querySelector('[data-gallery-target]')
    
    var layoutLookupCount = 4;
    var layoutLookup = [
        {
            "3x3": [[
                0, 0, 1,
                2, 3, 4,
                5, 6, 4,
            ], ["2x1", "1x1", "1x1", "1x1", "1x2", "1x1", "1x1"]], //ok
            "3x2": [[
                0, 0, 1,
                2, 3, 4,
            ], ["2x1", "1x1", "1x1", "1x1", "1x1"]], //ok
            "3x1": [[
                0, 1, 2, //0, 0, 1,
            ], ["1x1", "1x1", "1x1"]], //ok
            "2x3": [[
                0, 1,
                2, 1,
                3, 4,
            ], ["1x1", "1x2", "1x1", "1x1", "1x1"]], //ok
            "2x2": [[
                0, 0,
                1, 2,
            ], ["2x1", "1x1", "1x1"]], //ok
            "2x1": [[
                0, 1,
            ], ["1x1", "1x1"]], //ok
			"1x3": [[
                0, 
                0, 
                1,
			], ["1x2", "1x1"]], //ok
			"1x2": [[
                0, 
                1,
			], ["1x1", "1x1"]], //ok
			"1x1": [[
				0,
			], ["1x1"]], //ok
		},
        {
            "3x3": [[
                0, 1, 2,
                0, 3, 3,
                4, 3, 3,
            ], ["1x2", "1x1", "1x1", "2x2", "1x1"]], //ok
            "3x2": [[
                0, 1, 2,
                3, 4, 2,
            ], ["1x1", "1x1", "1x2", "1x1", "1x1"]], //ok
            "3x1": [[
                0, 0, 1, //0, 1, 2,
            ], ["2x1", "1x1"]], //ok
            "2x3": [[
                0, 0,
                1, 2,
                3, 2,
            ], ["2x1", "1x1", "1x2", "1x1"]], //ok
            "2x2": [[
                0, 1,
                2, 1,
            ], ["1x1", "1x2", "1x1"]], //ok
            "2x1": [[
                0, 0,
            ], ["2x1"]], //ok
			"1x3": [[
                0, 
                1, 
                1,
			], ["1x1", "1x2"]], //ok
			"1x2": [[
                0, 
                0,
			], ["1x2"]], //ok
			"1x1": [[
				0,
			], ["1x1"]], //ok
		},
        {
            "3x3": [[
                0, 1, 2,
                3, 1, 4,
                3, 5, 6,
            ], ["1x1", "1x2", "1x1", "1x2", "1x1", "1x1", "1x1"]], //ok
            "3x2": [[
                0, 1, 1,
                2, 3, 4,
            ], ["1x1", "2x1", "1x1", "1x1", "1x1"]], //ok
            "3x1": [[
                0, 1, 2, //0, 1, 1,
            ], ["1x1", "1x1", "1x1"]], //ok
            "2x3": [[
                0, 1,
                2, 1,
                2, 3,
            ], ["1x1", "1x2", "1x2", "1x1"]], //ok
            "2x2": [[
                0, 1,
                2, 2,
            ], ["1x1", "1x1", "2x1"]], //ok
            "2x1": [[
                0, 1,
            ], ["1x1", "1x1"]], //ok
			"1x3": [[
                0, 
                0, 
                1,
			], ["1x2", "1x1"]], //ok
			"1x2": [[
                0, 
                1,
			], ["1x1", "1x1"]], //ok
			"1x1": [[
				0,
			], ["1x1"]], //ok
		},
        {
            "3x3": [[
                0, 1, 2,
                3, 3, 2,
                3, 3, 4,
            ], ["1x1", "1x1", "1x2", "2x2", "1x1", "1x1"]], //ok
            "3x2": [[
                0, 1, 2,
                3, 1, 4,
            ], ["1x1", "1x2", "1x1", "1x1", "1x1"]], //ok
            "3x1": [[
                0, 1, 1, //0, 1, 2,
            ], ["1x1", "2x1"]], //ok
            "2x3": [[
                0, 1,
                2, 2,
                3, 4,
            ], ["1x1", "1x1", "2x1", "1x1", "1x1"]], //ok
            "2x2": [[
                0, 1,
                0, 2,
            ], ["1x2", "1x1", "1x1"]], //ok
            "2x1": [[
                0, 0,
			], ["2x1"]], //ok
			"1x3": [[
                0, 
                1, 
                1,
			], ["1x1", "1x2"]], //ok
			"1x2": [[
                0, 
                0,
			], ["1x2"]], //ok
			"1x1": [[
				0,
			], ["1x1"]], //ok
        }
    ];

    var init = function (forId, container) {
        //var blocks = @Html.Raw(BuildBlocksData());
        var blocksData = container.getAttribute("data-grid-blocks");
        var defaultGridHeight = container.hasAttribute("data-row-count") ? parseInt(container.getAttribute("data-row-count")) : NaN;
        var defaultLayoutType = container.hasAttribute("data-layout") ? parseInt(container.getAttribute("data-layout")) : 1;
        let gallery;
        let galleryId;
        let galleryButton;
        let selectedTag = "";
        var tags = document.querySelectorAll("[data-tag-id='" + forId + "']");

        if (galleryExtraButton) {
            galleryExtraButton.addEventListener('click', (e) => {
                galleryButton = e.target;
                galleryId = e.target.getAttribute('data-gallery-target');
                gallery = document.querySelector(`[data-gallery-id="${galleryId}"]`);

                if (gallery) {
                    const gridShowMoreBtn = document.querySelector(`[data-more-id="${forId}"]`);
                    selectedTag = "";
                    e.target.classList.add('selected');

                    for (var i = 0; i < tags.length; i++)
                        tags[i].classList.remove("selected");

                    if (gallery.classList.contains('hidden')) {
                        gallery.classList.remove('hidden');

                        gridShowMoreBtn.classList.add('hide');
                        container.classList.add('hide');

                    }
                }
            });
        }

        if (defaultGridHeight <= 0 || isNaN(defaultGridHeight))
            defaultGridHeight = 3;

        if (blocksData == null)
            return;

        var blocks = JSON.parse(blocksData);

		var moreBtn = document.querySelectorAll("[data-more-id='" + forId + "'] a")[0] || document.querySelectorAll("[data-more-id='" + forId + "'] button")[0];
        let defaultMoreHeight = 0;

        //Find elements
        for (var i = 0; i < blocks.length; i++) {
            blocks[i].Element = document.querySelectorAll("[data-block-id='" + forId + "-" + i + "']")[0];
            blocks[i].Source = { Left: 0, Top: 0, Width: 0, Height: 0, Opacity: 0 };
            blocks[i].Destination = { Left: 0, Top: 0, Width: 0, Height: 0, Opacity: 0 };
        }

        let resizeTicking = 0;
        let rowCount = 1;
        let containerHeight = 0;
        let destinationContainerHeight = 0;
        let moreHeight = 0;
        let destinationMoreHeight = 0;

        let gridWidth = 1;
        let gridHeight = 1;
        let visibleBlocks = [];

        var Lerp = function (v0, v1, t) {
            return v0 * (1 - t) + v1 * t
        };

        var UpdateSize = function () {
            var gridSize;//gridWidth + "x" + gridHeight;
            var gridSizeIndex = 0;
            var layoutType = defaultLayoutType;
            var blockOffset = 0;
            var blockIndex = 0;
            var blockCount = 0;
            var layout = null;

            switch (gridHeight) {
                case 6:
                    gridSize = [gridWidth + "x3", gridWidth + "x3"];
                    break;
                case 5:
                    gridSize = [gridWidth + "x3", gridWidth + "x2"];
                    break;
                case 4:
                    gridSize = [gridWidth + "x2", gridWidth + "x2"];
                    break;
                case 3:
                    gridSize = [gridWidth + "x3"];
                    break;
                case 2:
                    gridSize = [gridWidth + "x2"];
                    break;
                default:
                    gridSize = [gridWidth + "x1"];
                    break;                
            }

            for (var i = 0; i < visibleBlocks.length; i++) {
				if (layout == null || blockIndex >= blockCount) {
					layout = layoutLookup[layoutType % layoutLookupCount][gridSize[gridSizeIndex % gridSize.length]][1];
                    blockOffset = blockCount;
                    blockCount += layout.length;
                    layoutType++;
                    gridSizeIndex++;
                }
                var block = blocks[visibleBlocks[i]];

                block.Size = layout[blockIndex - blockOffset];

                switch (block.Size) {
                    case "1x2":
                    case "2x2":
                        if (blockIndex >= visibleBlocks.length - 3 && visibleBlocks.length - blockCount < 0)
                            block.Size = "1x1";
                        break;
                }

                blockIndex++;
            }
        };
/*
$mobile-width:			320px;
$tablet-width:			1024px;
$desktop-width:			1440px;
*/
        var Reorder = function (Initialize) {
            gridWidth = 3;
            gridHeight = defaultGridHeight;

            if (window.innerWidth < 1440) {
                gridWidth = 2;
            }

            if (window.innerWidth < 1024) {
                gridWidth = 1;
                var mobileRowCount = element.getAttribute('data-row-count-mobile');

                if (mobileRowCount && !isNaN(mobileRowCount) && gridHeight != mobileRowCount) {
                    gridHeight = mobileRowCount
                }
            }

            var grid = [];
            visibleBlocks = [];

            for (var i = 0; i < blocks.length; i++) {
                blocks[i].WasVisible = blocks[i].Visible;
                blocks[i].Visible = false;

                if (selectedTag != "" && !blocks[i].Tags.includes(selectedTag))
                    continue;

                visibleBlocks.push(i);
            }

            UpdateSize();

            for (var row = 0; row < rowCount; row++) {

                for (var i = 0; i < gridWidth * gridHeight; i++)
                    grid.push(false);

                var width = gridWidth;
                var height = row * gridHeight + gridHeight;

                //Try to place blocks
                for (var i = 0; i < visibleBlocks.length; i++) {
                    var foundPos = false;
                    var pos = { x: 0, y: 0 };
                    var size = { w: 0, h: 0 }
                    var block = blocks[visibleBlocks[i]];

                    if (block.Visible)
                        continue;

                    if (gridWidth == 1) {
                        if (i < height) {
                            foundPos = true;
                            pos.y = i;
                            size.w = 1;
                            size.h = 1;
                        }
                    } else {
                        for (var y = row * gridHeight; y < height && !foundPos; y++) {
                            for (var x = 0; x < width && !foundPos; x++) {
                                switch (block.Size) {
                                    case "1x1": {
                                        if (!grid[y * width + x]) {
                                            foundPos = true;
                                            pos.x = x;
                                            pos.y = y;
                                            size.w = 1;
                                            size.h = 1;
                                            grid[y * width + x] = true;
                                        }
                                    }
                                        break;
                                    case "1x2": {
                                        if (y <= height - 2 && !grid[y * width + x] && !grid[(y + 1) * width + x]) {
                                            foundPos = true;
                                            pos.x = x;
                                            pos.y = y;
                                            size.w = 1;
                                            size.h = 2;
                                            grid[y * width + x] = true;
                                            grid[(y + 1) * width + x] = true;
                                        }
                                    }
                                        break;
                                    case "2x1": {
                                        if (x <= width - 2 && !grid[y * width + x] && !grid[y * width + (x + 1)]) {
                                            foundPos = true;
                                            pos.x = x;
                                            pos.y = y;
                                            size.w = 2;
                                            size.h = 1;
                                            grid[y * width + x] = true;
                                            grid[y * width + (x + 1)] = true;
                                        }
                                    }
                                        break;
                                    case "2x2": {
                                        if (x <= width - 2 && y <= height - 2 && !grid[y * width + x] && !grid[y * width + (x + 1)] && !grid[(y + 1) * width + x] && !grid[(y + 1) * width + (x + 1)]) {
                                            foundPos = true;
                                            pos.x = x;
                                            pos.y = y;
                                            size.w = 2;
                                            size.h = 2;
                                            grid[y * width + x] = true;
                                            grid[y * width + (x + 1)] = true;
                                            grid[(y + 1) * width + x] = true;
                                            grid[(y + 1) * width + (x + 1)] = true;
                                        }
                                    }
                                        break;
                                }
                            }
                        }
                    }

                    block.Visible = foundPos;
                    block.Left = pos.x;
                    block.Top = pos.y;
                    block.Width = size.w;
                    block.Height = size.h;
                }
            }

            container.style.overflow = "hidden";
			container.style.position = "relative";

            destinationContainerHeight = 0;

            var moreHidden = true;

            for (var i = 0; i < visibleBlocks.length; i++)
                moreHidden &= blocks[visibleBlocks[i]].Visible;

            for (var i = 0; i < blocks.length; i++) {
                var block = blocks[i];
                //moreHidden &= block.Visible;

				if (block.Visible) {
					var rect = container.getBoundingClientRect();

					block.Destination.Left = (block.Left * (rect.width / width));
                    block.Destination.Top = (block.Top * (rect.width / width / 4 * 3));
                    block.Destination.Width = (rect.width / width * block.Width);
                    block.Destination.Height = ((rect.width / width / 4 * 3) * block.Height);
				}
                block.Destination.Opacity = block.Visible ? 1.0 : 0.0;

                //First render
                if (Initialize || !block.WasVisible) {
                    block.Source.Left = block.Destination.Left;
                    block.Source.Top = block.Destination.Top;
                    block.Source.Width = block.Destination.Width;
                    block.Source.Height = block.Destination.Height;
                    block.Source.Opacity = Initialize ? block.Destination.Opacity : 0;

                    block.Element.style.display = block.Visible ? "flex" : "none";
                    block.Element.style.position = "absolute";
                    block.Element.style.left = block.Source.Left + "px";
                    block.Element.style.top = block.Source.Top + "px";
                    block.Element.style.width = block.Source.Width + "px";
                    block.Element.style.height = block.Source.Height + "px";
				}

                if (block.Visible && block.Destination.Top + block.Destination.Height > destinationContainerHeight)
                    destinationContainerHeight = block.Destination.Top + block.Destination.Height;
            }

            if (Initialize && defaultMoreHeight == 0)
                defaultMoreHeight = moreBtn.parentElement.parentElement.clientHeight;

            if (moreHidden) {
                destinationMoreHeight = 0;
            } else {
                destinationMoreHeight = defaultMoreHeight;
            }

            //First render
            if (Initialize) {
                containerHeight = destinationContainerHeight;
                container.style.height = containerHeight + "px";

                moreHeight = destinationMoreHeight;
                moreBtn.parentElement.parentElement.style.height = moreHeight + "px";
            }
        };

        var ShowMore = function () {
            rowCount++;
            Reorder(false);
        };

        Reorder(true);

        var animationSpeed = 0.7;

        var Animate = function () {
            setInterval(function () {
                var changed = false;

                for (var i = 0; i < blocks.length; i++) {
                    var block = blocks[i];
                    if (block.Source.Left != block.Destination.Left) {
                        block.Source.Left = Lerp(block.Destination.Left, block.Source.Left, animationSpeed);
                        if (block.Source.Left > block.Destination.Left - 0.1 && block.Source.Left < block.Destination.Left + 0.1)
                            block.Source.Left = block.Destination.Left;
                        changed = true;
                    }
                    if (block.Source.Top != block.Destination.Top) {
                        block.Source.Top = Lerp(block.Destination.Top, block.Source.Top, animationSpeed);
                        if (block.Source.Top > block.Destination.Top - 0.1 && block.Source.Top < block.Destination.Top + 0.1)
                            block.Source.Top = block.Destination.Top;
                        changed = true;
                    }
                    if (block.Source.Width != block.Destination.Width) {
                        block.Source.Width = Lerp(block.Destination.Width, block.Source.Width, animationSpeed);
                        if (block.Source.Width > block.Destination.Width - 0.1 && block.Source.Width < block.Destination.Width + 0.1)
                            block.Source.Width = block.Destination.Width;
                        changed = true;
                    }
                    if (block.Source.Height != block.Destination.Height) {
                        block.Source.Height = Lerp(block.Destination.Height, block.Source.Height, animationSpeed);
                        if (block.Source.Height > block.Destination.Height - 0.1 && block.Source.Height < block.Destination.Height + 0.1)
                            block.Source.Height = block.Destination.Height;
                        changed = true;
                    }
                    if (block.Source.Opacity != block.Destination.Opacity) {
                        block.Source.Opacity = Lerp(block.Destination.Opacity, block.Source.Opacity, animationSpeed);
                        if (block.Source.Opacity > block.Destination.Opacity - 0.1 && block.Source.Opacity < block.Destination.Opacity + 0.1)
                            block.Source.Opacity = block.Destination.Opacity;
                        changed = true;
                    }
                }

                if (containerHeight != destinationContainerHeight) {
                    containerHeight = Lerp(destinationContainerHeight, containerHeight, animationSpeed);
                    if (containerHeight > destinationContainerHeight - 0.1 && containerHeight < destinationContainerHeight + 0.1)
                        containerHeight = destinationContainerHeight;
                    changed = true;
                }

                if (moreHeight != destinationMoreHeight) {
                    moreHeight = Lerp(destinationMoreHeight, moreHeight, animationSpeed);
                    if (moreHeight > destinationMoreHeight - 0.1 && moreHeight < destinationMoreHeight + 0.1)
                        moreHeight = destinationMoreHeight;
                    changed = true;
                }

                if (changed) {
                    window.requestAnimationFrame(function () {
                        for (var i = 0; i < blocks.length; i++) {
                            var block = blocks[i];
                            block.Element.style.left = block.Source.Left + "px";
                            block.Element.style.top = block.Source.Top + "px";
                            block.Element.style.width = block.Source.Width + "px";
                            block.Element.style.height = block.Source.Height + "px";
                            block.Element.style.opacity = block.Source.Opacity;
                            block.Element.style.display = block.Source.Opacity == 0.0 ? "none" : "flex";
                        }
                        container.style.height = containerHeight + "px";
                        moreBtn.parentElement.parentElement.style.height = moreHeight + "px";
                    });
                }
            }, 1000 / 60);
        };

        window.addEventListener("resize", function (e) {
            if (resizeTicking >= 0) {
                if (resizeTicking > 0)
                    clearTimeout(resizeTicking);
                resizeTicking = setTimeout(function () {
                    resizeTicking = -1;
                    window.requestAnimationFrame(function () {
                        Reorder(false);
                        resizeTicking = 0;
                    });
                }, 100);
            }
        });

        moreBtn.onclick = function () { ShowMore(); };

        for (var i = 0; i < tags.length; i++) {
            if (tags[i].hasAttribute('data-tag-default'))
                selectedTag = tags[i].getAttribute("data-tag");

            tags[i].onclick = function (e) {
                selectedTag = this.getAttribute("data-tag");
                for (var i = 0; i < tags.length; i++)
                    tags[i].classList.remove("selected");
                this.classList.add("selected");

                if (gallery) {
                    if (!gallery.classList.contains('hidden')) {
                        gallery.classList.add('hidden');
                        
                    }
                    if (galleryButton.classList.contains('selected'))
                        galleryButton.classList.remove('selected');
                }

                if (container.classList.contains('hide')) {
                    container.classList.remove('hide');
                }

                if (moreBtn.classList.contains('hide')) {
                    moreBtn.classList.remove('hide');
                }

                Reorder(false);
            };
        }

        Reorder(true);

        Animate();
    };

    var id = element.getAttribute("data-grid-id");
    init(id, element);
};